import React from 'react';
import Header from '../components/Header';
import { useLanguage } from '../context/LanguageContext';
import { useCart } from '../context/CartContext';
import { usePageMeta } from '../utils/usePageMeta';

const HowItWorksPage = () => {
  const { t, language } = useLanguage();
  const { items } = useCart();
  const hasCartItems = items.length > 0;

  usePageMeta({
    title: t('howItWorksPage.metaTitle'),
    description: t('howItWorksPage.metaDescription'),
    path: '/how-it-works',
    lang: language,
  });

  return (
    <div className="min-h-screen bg-white">
      <Header title={t('header.howItWorks')} showBack />

      <main className={`px-4 py-6 max-w-[600px] mx-auto animate-fade-in ${hasCartItems ? 'pb-[100px]' : 'pb-10'}`}>
        <div className="text-center mb-8">
          <h1 className="text-[26px] font-bold text-black m-0 mb-2">{t('howItWorksPage.title')}</h1>
          <p className="text-base text-gray-500 m-0">{t('howItWorksPage.subtitle')}</p>
        </div>

        <div className="flex flex-col gap-5 mb-8">
          <div className="flex gap-4 p-5 bg-gray-100 rounded-2xl transition-all duration-200 hover:translate-x-1 hover:shadow-lg">
            <div className="w-10 h-10 bg-dewalt rounded-full flex items-center justify-center text-xl font-bold text-black flex-shrink-0">1</div>
            <div>
              <h3 className="text-lg font-semibold text-black m-0 mb-1.5">{t('howItWorksPage.step1Title')}</h3>
              <p className="text-[15px] text-gray-600 m-0 leading-relaxed">{t('howItWorksPage.step1Desc')}</p>
            </div>
          </div>

          <div className="flex gap-4 p-5 bg-gray-100 rounded-2xl transition-all duration-200 hover:translate-x-1 hover:shadow-lg">
            <div className="w-10 h-10 bg-dewalt rounded-full flex items-center justify-center text-xl font-bold text-black flex-shrink-0">2</div>
            <div>
              <h3 className="text-lg font-semibold text-black m-0 mb-1.5">{t('howItWorksPage.step2Title')}</h3>
              <p className="text-[15px] text-gray-600 m-0 leading-relaxed">{t('howItWorksPage.step2Desc')}</p>
            </div>
          </div>

          <div className="flex gap-4 p-5 bg-gray-100 rounded-2xl transition-all duration-200 hover:translate-x-1 hover:shadow-lg">
            <div className="w-10 h-10 bg-dewalt rounded-full flex items-center justify-center text-xl font-bold text-black flex-shrink-0">3</div>
            <div>
              <h3 className="text-lg font-semibold text-black m-0 mb-1.5">{t('howItWorksPage.step3Title')}</h3>
              <p className="text-[15px] text-gray-600 m-0 leading-relaxed">{t('howItWorksPage.step3Desc')}</p>
            </div>
          </div>

          <div className="flex gap-4 p-5 bg-gray-100 rounded-2xl transition-all duration-200 hover:translate-x-1 hover:shadow-lg">
            <div className="w-10 h-10 bg-dewalt rounded-full flex items-center justify-center text-xl font-bold text-black flex-shrink-0">4</div>
            <div>
              <h3 className="text-lg font-semibold text-black m-0 mb-1.5">{t('howItWorksPage.step4Title')}</h3>
              <p className="text-[15px] text-gray-600 m-0 leading-relaxed">{t('howItWorksPage.step4Desc')}</p>
            </div>
          </div>
        </div>

        <div className="bg-[#fffbf0] border-2 border-dewalt rounded-2xl p-5">
          <h2 className="text-lg font-semibold text-black m-0 mb-3">{t('howItWorksPage.importantTitle')}</h2>
          <ul className="m-0 pl-5">
            <li className="text-[15px] text-gray-700 leading-[1.6] mb-1.5">{t('howItWorksPage.important1')}</li>
            <li className="text-[15px] text-gray-700 leading-[1.6] mb-1.5">{t('howItWorksPage.important2')}</li>
            <li className="text-[15px] text-gray-700 leading-[1.6] mb-1.5">{t('howItWorksPage.important3')}</li>
            <li className="text-[15px] text-gray-700 leading-[1.6] mb-0">{t('howItWorksPage.important4')}</li>
          </ul>
        </div>
      </main>
    </div>
  );
};

export default HowItWorksPage;
